import type {
  EstadoSimulacao,
  FluxoDetalhe,
  FluxoForm,
  FluxoResumo,
  ResultadoPublicacao,
  VersaoFluxo,
} from '@mymaxx/shared';
import { api } from './api';

const base = '/v1/fluxos';

export const fluxosApi = {
  listar: () => api.get<FluxoResumo[]>(base),
  detalhe: (id: string) => api.get<FluxoDetalhe>(`${base}/${id}`),
  criar: (dados: FluxoForm) => api.post<FluxoDetalhe>(base, dados),
  atualizar: (id: string, dados: FluxoForm) => api.put<FluxoDetalhe>(`${base}/${id}`, dados),
  excluir: (id: string) => api.delete<void>(`${base}/${id}`),

  salvarRascunho: (id: string, definicao: unknown) =>
    api.put<FluxoDetalhe>(`${base}/${id}/rascunho`, { definicao }),
  validar: (definicao: unknown) =>
    api.post<{ valido: boolean; problemas: string[] }>(`${base}/validar`, { definicao }),
  publicar: (id: string) => api.post<ResultadoPublicacao>(`${base}/${id}/publicar`),

  versoes: (id: string) => api.get<VersaoFluxo[]>(`${base}/${id}/versoes`),
  restaurarVersao: (id: string, versaoId: string) =>
    api.post<FluxoDetalhe>(`${base}/${id}/versoes/${versaoId}/restaurar`),

  iniciarSimulacao: (id: string, usarRascunho: boolean) =>
    api.post<EstadoSimulacao>(`${base}/${id}/simular`, { usarRascunho }),
  responderSimulacao: (sessaoId: string, texto: string) =>
    api.post<EstadoSimulacao>(`${base}/simular/mensagem`, { sessaoId, texto }),
  pularEspera: (sessaoId: string) =>
    api.post<EstadoSimulacao>(`${base}/simular/${sessaoId}/pular-espera`),
  encerrarSimulacao: (sessaoId: string) => api.delete<void>(`${base}/simular/${sessaoId}`),
};
